import { csx } from '@vtex/admin-ui'

const styles = {
  checkboxContent: csx({
    marginLeft: '$space-7',
    marginTop: '$space-3',
  }),
  numberBox: csx({
    gap: '$space-3',
  }),
  marginGroup: csx({
    marginTop: '$space-6',
    marginBottom: '$space-4',
  }),
  marginMaxUsage: csx({
    marginBottom: '$space-8',
  }),
}

export default styles
